<div class="confirm-modal-container">
    <div [id]="modalId" class="shadow-lg modal-bg p-2">
        <div class="content-panel b-border">
            <div class="modal-header">
                <h5 class="modal-title" [translate]="title"></h5>
            </div>
            <div class="import-modal-body">
                <p [translate]="question"></p>
            </div>
            <div class="modal-footer d-flex gap-2 p-2">
                <button-control
                    buttonType="button"
                    themeColor="secondary"
                    [buttonText]="'common.no'"
                    (onClick)="btnReject()">
                </button-control>
                <button-control
                    buttonType="button"
                    themeColor="primary"
                    [buttonText]="'common.yes'"
                    (onClick)="btnConfirm()">
                </button-control>
            </div>
        </div>
    </div>
</div>
